import { render, staticRenderFns } from "./rejected-reason.vue?vue&type=template&id=c0d113be&lang=pug&"
import script from "./rejected-reason.vue?vue&type=script&lang=js&"
export * from "./rejected-reason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports